import {WindowService} from "@app/core/shared/domain/window.service";
import {Inject, Injectable} from "@angular/core";
import {DOCUMENT} from "@angular/common";
/**
 * Implementation of the WindowService interface for client-side environments.
 */
@Injectable()
export class WindowClientService implements WindowService{

    constructor(@Inject(DOCUMENT) private _doc: Document) {}

    getWindow(): Window | null {
        return this._doc.defaultView;
    }

    getLocalStorage(): Storage | null {
        const window = this.getWindow();
        return window ? window.localStorage : null;
    }
}